import { render, staticRenderFns } from "./HotelFeeRuleView.vue?vue&type=template&id=c2da87c6&scoped=true&"
import script from "./HotelFeeRuleView.vue?vue&type=script&lang=js&"
export * from "./HotelFeeRuleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2da87c6",
  null
  
)

export default component.exports